import React, { useEffect, useState } from 'react';
import SearchIcon from '../assets/search-icon';

const Header = ({ title, subtitle, buttonConfigs, searchText, onSearch }) => {
  const [value, setValue] = useState(searchText);

  useEffect(() => {
    setValue(searchText);
  }, [searchText]);

  return (
    <div className="w-full bg-cover bg-center" style={{ backgroundImage: 'url(/gedung-sate.jpg)' }}>
      <div className="p-9 py-10 lg:py-20 lg:px-32 flex flex-col lg:flex-row justify-center items-center h-full w-full bg-primary-500 bg-opacity-80">
        <div className="w-full flex flex-col items-center lg:items-start justify-between text-center lg:text-left mb-5 lg:my-0">
          <h1 className="text-white text-2xl font-bold md:text-5xl mb-5">{title}</h1>
          <h4 className="text-white text-base md:text-base">{subtitle}</h4>
        </div>
        <form className="w-full lg:w-4/12 flex bg-white rounded-lg justify-between">
          <input
            type="text"
            id={buttonConfigs.id}
            className="p-5 w-10/12 text-sm font-semibold text-gray-900 rounded-l-lg focus:outline-none"
            placeholder={buttonConfigs.placeholder}
            value={value}
            disabled={buttonConfigs.disabled}
            onChange={(e) => setValue(e.target.value)}
          />
          <button
            type="submit"
            disabled={buttonConfigs.disabled}
            className="p-5 h-full"
            onClick={(e) => {
              e.preventDefault();
              onSearch(value);
            }}
          >
            <SearchIcon />
          </button>
        </form>
      </div>
    </div>
  );
};

export default Header;
